import designItem from './DesignFormItem.vue'
const DesignFormItem = {
  install: function (Vue) {
    Vue.component('DesignFormItem', designItem)
  }
}
export default DesignFormItem
